import { ISuperPropertiesArguments } from "../mixpanel-utils.types";

export interface ITrackNPSEventArguments {
  useAuthData: ISuperPropertiesArguments["useAuthData"];
  classStartTime?: string;
  classTopic?: string;
  classSubject?: string;
  trialClassId: string;
  source: NPSTrackingSource;
  npsRating?: string | null;
  parentNumber?: string | null;
  feedback?: string | null;
}
export interface ITrackNPSEventpayload {
  [key: string]: string | string[] | boolean | null | Document["referrer"];
}

export enum NPSTrackingSource {
  FEEDBACK_LINK = "Feedback Link",
  ZOOM_END_MEETING = "Zoom End Meeting",
  TEACHER_ENDED_CLASS = "Teacher ended class",
  APP_RELAUNCH = "App Relaunch"
}
